// Local Imports
import { Layout } from '../components/shared';
// import Dashboard from '../panel/Dashboard';
import Users from '../panel/Users';
import Login from '../panel/Auth/Login';
import { UsersIcon, ServicesIcon, SalonsIcon, BookingIcon } from '../assets/icons';
import Signup from '../panel/Auth/Signup';
import ForgetPassword from '../panel/Auth/ForgetPassword';
import ResetPassword from '../panel/Auth/ResetPassword';
import Services from '../panel/Services';
import Salons from '../panel/Salons';
import Redirection from '../panel/Redirection';
import Profile from '../panel/Profile';
import Bookings from '../panel/Bookings';

export const sideMenuRoutes = [
  // {
  //   path: '/',
  //   text: 'Dashboard',
  //   icon: <DashboardIcon />,
  //   activeIcon: <DashboardIcon />
  // },

  {
    path: '/',
    text: 'Users',
    icon: <UsersIcon />,
    activeIcon: <UsersIcon />
  },
  {
    path: '/services',
    text: 'Services',
    icon: <ServicesIcon />,
    activeIcon: <ServicesIcon />
  },
  {
    path: '/salons',
    text: 'Salons',
    icon: <SalonsIcon />,
    activeIcon: <SalonsIcon />
  },
  {
    path: '/bookings',
    text: 'Bookings',
    icon: <BookingIcon />,
    activeIcon: <BookingIcon />
  }
];

// PRIVATE ROUTES
export const privateRoutes = [
  // {
  //   path: '/',
  //   moduleName: 'Dashboard',
  //   element: (
  //     <Layout>
  //       <Dashboard />
  //     </Layout>
  //   )
  // },
  {
    path: '/',
    moduleName: 'Users',
    element: (
      <Layout>
        <Users />
      </Layout>
    )
  },

  {
    path: '/affiliations',
    moduleName: 'Affiliations',
    element: (
      <Layout>
        <h1>Affiliations</h1>
      </Layout>
    )
  },
  {
    path: '/services',
    moduleName: 'Services',
    element: (
      <Layout>
        <Services />
      </Layout>
    )
  },
  {
    path: '/salons',
    moduleName: 'Salons',
    element: (
      <Layout>
        <Salons />
      </Layout>
    )
  },
  {
    path: '/bookings',
    moduleName: 'Bookings',
    element: (
      <Layout>
        <Bookings />
      </Layout>
    )
  },
  {
    path: '/refunds',
    moduleName: 'Refunds',
    element: (
      <Layout>
        <h1>Refunds</h1>
      </Layout>
    )
  },
  {
    path: '/app-settings',
    moduleName: 'App Settings',
    element: (
      <Layout>
        <h1>App Settings</h1>
      </Layout>
    )
  },

  {
    path: '/profile',
    moduleName: 'Profile',
    element: (
      <Layout>
        <Profile />
      </Layout>
    )
  }
];

// PUBLIC ROUTES
export const publicRoutes = [
  {
    path: '/login',
    moduleName: 'Athentication',
    element: <Login />
  },
  {
    path: '/sign-up',
    moduleName: 'Athentication',
    element: <Signup />
  },
  {
    path: '/forgot-password',
    moduleName: 'Athentication',
    element: <ForgetPassword />
  },
  {
    path: '/reset-password',
    moduleName: 'Athentication',
    element: <ResetPassword />
  },
  {
    path: '/redirection',
    moduleName: 'Athentication',
    element: <Redirection />
  }
];
